import {AbstractCode} from 'src/codes/abstract';

/**
 * システム列 data_flg（I/U/D）
 * Trade / 出金申請 / 会員マスタなど複数テーブルで共有する更新区分
 */
const CodeList = [
  {
    id: 'I',
    value: '挿入',
  },
  {
    id: 'U',
    value: '更新',
  },
  {
    id: 'D',
    value: '削除',
  },
] as const;

export type DataFlag = typeof CodeList[number];

const CodeClass = new AbstractCode(CodeList);

const NameAccessor = CodeList.reduce(
  (result, elem) => {
    result[elem.value] = elem;
    return result;
  },
  {} as Record<DataFlag['value'], DataFlag>,
);

export const DataFlag = Object.assign(CodeClass, NameAccessor);
